"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Item = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  maxWidth: _constants.maxWidth,
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: theme.spacing(4),
  justifyContent: 'center',
  alignItems: 'center'
}));
const Item = exports.Item = (0, _mui.styled)('img')(({
  theme
}) => ({
  height: '25px'
}));